export const ROUTE_OFFICE_HOURS = "/bookings";
